import {
    Divider,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    
  } from "@chakra-ui/react";
  import React, {  useState, useMemo } from "react";
  import Form from "react-bootstrap/Form";
  import Col from "react-bootstrap/Col";
  import Row from "react-bootstrap/Row";
  import moment from "moment";
  import { InputGroup, Tab, Tabs } from "react-bootstrap";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import InvoiceInfo from "./components/invoicceInfo";
import RefundInfo from "./components/refundInfo";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import InvoiceGstInfo from "./components/invoiceGstInfo";
import { calculateTotalCredit } from "jsFunctions/helperFunctions";
import PaymentRecordInfo from "./components/paymentRecordsInfo";
import InvoiceTdsInfo from "./components/invoiceTdsInfo";
import { sumOfPaymentRecordAmount } from "utiils/halper";
  
  const DataRow = ({ label, value,type }) => {
    return (
      <>
        <Form.Label>{label}</Form.Label>
      {type === 'Amount' 
      ?
      <InputGroup>
        <InputGroup.Text style={{height:'2rem', border:0, background:'lightGray'}}><span className="rupee-symbol">₹</span> </InputGroup.Text>
        <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? formatAmountIndianRupees(value) : " "}
        disabled
      />
      </InputGroup>
      :
      <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? value : " "}
        disabled
      />
      }
      </>
    );
  };
  
  const SalesInvoiceInfoModel = ({ openInfoModal, closeInfoModal, selectedItem, role, expenseType,moduleInfo }) => {
  
    const [activeTab, setActiveTab] = useState("information");
    const [historyTab, setHistoryTab] = useState("requested");  

    const clientName = useMemo(() => {
      const cId = selectedItem?.clId
      if (cId) {
          return cId.clName || "";
      }
  }, [selectedItem]);
  
  const getPaymentTerms = (days)=>{
    const terms = moduleInfo?.pyTrms;
    const selected = terms?.find((t)=>t.days === days);
    return selected?.name || ""
  }
  const remainingAmount = useMemo(() => {
    const list = selectedItem?.pmtRc || [];
    const crList = selectedItem?.crApl?.list || [];
    const sumOfCredit = calculateTotalCredit(crList)
    const total = sumOfPaymentRecordAmount(list)
    
    const totalPayAmount = parseFloat(selectedItem?.pyInfo?.apAmt || 0) - parseFloat(selectedItem?.tdsApl?.tdsAmt || 0) - parseFloat(sumOfCredit) - parseFloat(total);
    

    return totalPayAmount;
  }, [selectedItem]);
    return (
      <div>
        <Modal
          isOpen={openInfoModal}
          onClose={closeInfoModal}
          size="xl"
          className="modal-main"
        >
          <ModalOverlay />
          <ModalContent
            top="0" // Position it at the top
            margin="0 auto" // Center it horizontally
            bottom="0"
            className="info-model"
          >
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header mt-0">
                <span>{expenseType} Details</span>
              </ModalHeader>
              <ModalCloseButton />
            </div>
            <ModalBody>
              <Form className="addForm">
                <Tabs
                  id="justify-tab-example1"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className=""
                  justify
                >
                  <Tab
                    eventKey="information"
                    title="Information"
                    className="main-tab-item"
                  >
                    <div className="card">
                      <h5 className="heading-h5">Proforma Details</h5>

                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Proforma Number"
                            value={InvoiceNumberFormate(selectedItem.pfiNo)}
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Proforma Date"
                            value={
                              selectedItem.pfiDt
                                ? moment(selectedItem.pfiDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            }
                          />
                        </Col>
                      </Row>
                      <h5 className="heading-h5">Invoice Details</h5>

                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Invoice Number"
                            value={InvoiceNumberFormate(selectedItem.inNo)}
                          />
                        </Col>
                        <Col></Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Invoice Date"
                            value={
                              selectedItem.inDt
                                ? moment(selectedItem.inDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            }
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Invoice Currency"
                            value={selectedItem?.inCr}
                          />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Payment Terms"
                            value={getPaymentTerms(selectedItem?.tDays)}
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Due Date"
                            value={
                              selectedItem.duDt
                                ? moment(selectedItem.duDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            }
                          />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <Form.Label>Subject Of Invoice</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            disabled
                            value={selectedItem?.invSub}
                          />
                        </Col>
                      </Row>

                      <Divider
                        className="info-divider"
                        orientation="horizontal"
                        m={3}
                      />
                      <h5 className="heading-h5">Invoice Type</h5>

                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Major Type"
                            value={selectedItem?.mjId?.val}
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Minor Type"
                            value={selectedItem.mnId?.val}
                          />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Minor Sub Category"
                            value={selectedItem.msId?.val}
                          />
                        </Col>
                        <Col></Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow label="Client Name" value={clientName} />
                        </Col>
                        <Col>
                          <DataRow
                            label="Project Name"
                            value={selectedItem?.prId?.prj}
                          />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            disabled
                            value={selectedItem?.rmks}
                          />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <Form.Label>Customer Notes</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            disabled
                            value={selectedItem?.cNts}
                          />
                        </Col>
                      </Row>

                      <Divider
                        className="info-divider"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Payment Information</h5>
                      <PaymentRecordInfo selectedItem = {selectedItem} remainingAmount={remainingAmount} expenseType="custom" currency={selectedItem?.inCr}/>
                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Refund Amount Information</h5>
                      <RefundInfo selectedItem={selectedItem} currency={selectedItem?.inCr}/>

                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Tds Deducted</h5>
                      <InvoiceTdsInfo selectedItem={selectedItem} currency={selectedItem?.inCr}/>
                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Invoice</h5>
                      <InvoiceInfo selectedItem={selectedItem} />

                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">GST Applicable</h5>
                      <InvoiceGstInfo selectedItem={selectedItem} />
                    </div>
                  </Tab>
                  {role === "Manager" || role === "Admin" ? (
                    <Tab eventKey="history" title="History">
                      <Form className="addForm addform2">
                        <Tabs
                          id="justify-tab-example3"
                          activeKey={historyTab}
                          onSelect={(k) => setHistoryTab(k)}
                          transition={true}
                          className="mt-0"
                        >
                          <Tab
                            eventKey="requested"
                            className="inner-tab"
                            title="Requested"
                          >
                            <div className="inner-card">
                              <h5 className="heading-h5">
                                Requested Amount Details
                              </h5>
                              <Row className="info-row">
                                <Col className="check-cross-mark mt-2">
                                  <Form.Label>
                                    <span
                                      className={
                                        selectedItem.pyInfo.sts !== 0
                                          ? "checkmark"
                                          : "crossmark"
                                      }
                                    ></span>{" "}
                                    Is requested amount send for approval?
                                  </Form.Label>
                                  <br />
                                </Col>
                              </Row>
                              <Row className="info-row">
                                <Col>
                                  <DataRow
                                    label="Requested At"
                                    value={
                                      selectedItem.pyInfo?.rqAt
                                        ? moment(
                                            selectedItem.pyInfo?.rqAt
                                          ).format("DD-MMM-yyyy hh:mm A")
                                        : ""
                                    }
                                  />
                                </Col>
                                <Col>
                                  <DataRow
                                    label="Requested By"
                                    value={selectedItem.pyInfo?.rqBy?.name}
                                  />
                                </Col>
                              </Row>

                              <Divider
                                className="info-divider mt-3"
                                orientation="horizontal"
                              />
                              <h5 className="heading-h5">
                                Last Updated Details
                              </h5>

                              <Row className="info-row mb-3">
                                <Col>
                                  <DataRow
                                    label="Last Updated At"
                                    value={
                                      selectedItem.upAt
                                        ? moment(selectedItem.upAt).format(
                                            "DD-MMM-yyyy hh:mm A"
                                          )
                                        : ""
                                    }
                                  />
                                </Col>
                                <Col>
                                  <DataRow
                                    label="Last Updated By"
                                    value={selectedItem.upBy?.name}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Tab>

                          {selectedItem.pyInfo?.sts !== 2 ? (
                            <Tab eventKey="approved" title="Approved">
                              <div className="inner-card">
                                <h5 className="heading-h5">
                                  Requested Amount Details
                                </h5>
                                <Row className="info-row">
                                  <Col className="check-cross-mark mt-2">
                                    <Form.Label>
                                      <span
                                        className={
                                          selectedItem.pyInfo?.sts === 1
                                            ? "checkmark"
                                            : "crossmark"
                                        }
                                      ></span>{" "}
                                      Is requested amount is approved ?
                                    </Form.Label>
                                    <br />
                                  </Col>
                                </Row>
                                <Row className="info-row">
                                  <Col>
                                    <DataRow
                                      label="Approved At"
                                      value={
                                        selectedItem.pyInfo?.acnAt
                                          ? moment(
                                              selectedItem.pyInfo?.acnAt
                                            ).format("DD-MMM-yyyy hh:mm A")
                                          : ""
                                      }
                                    />
                                  </Col>
                                  <Col>
                                    <DataRow
                                      label="Approved By"
                                      value={selectedItem.pyInfo?.acnBy?.name}
                                    />
                                  </Col>
                                </Row>

                                <Divider
                                  className="info-divider mt-3"
                                  orientation="horizontal"
                                />
                                <h5 className="heading-h5">
                                  Last Updated Details
                                </h5>

                                <Row className="info-row mb-3">
                                  <Col>
                                    <DataRow
                                      label="Last Updated At"
                                      value={
                                        selectedItem.upAt
                                          ? moment(selectedItem.upAt).format(
                                              "DD-MMM-yyyy hh:mm A"
                                            )
                                          : ""
                                      }
                                    />
                                  </Col>
                                  <Col>
                                    <DataRow
                                      label="Last Updated By"
                                      value={selectedItem.upBy?.name}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </Tab>
                          ) : (
                            <Tab eventKey="approved" title="Rejected">
                              <div className="inner-card">
                                <h5 className="heading-h5">
                                  Requested Amount Details
                                </h5>
                                <Row className="info-row">
                                  <Col className="check-cross-mark mt-2">
                                    <Form.Label>
                                      <span
                                        className={
                                          selectedItem.pyInfo?.sts !== 2
                                            ? "checkmark"
                                            : "crossmark"
                                        }
                                      ></span>{" "}
                                      Is requested amount is rejected ?
                                    </Form.Label>
                                    <br />
                                  </Col>
                                </Row>
                                <Row className="info-row">
                                  <Col>
                                    <DataRow
                                      label="Rejected At"
                                      value={
                                        selectedItem.pyInfo?.acAt
                                          ? moment(
                                              selectedItem.pyInfo?.acAt
                                            ).format("DD-MMM-yyyy hh:mm A")
                                          : ""
                                      }
                                    />
                                  </Col>
                                  <Col>
                                    <DataRow
                                      label="Rejected By"
                                      value={selectedItem.pyInfo?.acnBy?.name}
                                    />
                                  </Col>
                                </Row>

                                <Divider
                                  className="info-divider mt-3"
                                  orientation="horizontal"
                                />
                                <h5 className="heading-h5">
                                  Last Updated Details
                                </h5>

                                <Row className="info-row mb-3">
                                  <Col>
                                    <DataRow
                                      label="Last Updated At"
                                      value={
                                        selectedItem.upAt
                                          ? moment(selectedItem.upAt).format(
                                              "DD-MMM-yyyy hh:mm A"
                                            )
                                          : ""
                                      }
                                    />
                                  </Col>
                                  <Col>
                                    <DataRow
                                      label="Last Updated By"
                                      value={selectedItem.upBy?.name}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </Tab>
                          )}
                        </Tabs>
                      </Form>
                    </Tab>
                  ) : (
                    <Tab eventKey="" title="" disabled></Tab>
                  )}
                </Tabs>
              </Form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    );
  };
  
  export default SalesInvoiceInfoModel;
  